<template>
  <div class="dd-container">
    <vue-particles
      color="#fff"
      :particleOpacity="0.7"
      :particlesNumber="100"
      shapeType="circle"
      :particleSize="4"
      linesColor="#fff"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="4"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
      class="lizi"
      style="height:100%"
    >
    </vue-particles>
    <span class="dd-system-title">测绘所房屋管理系统</span>
    <div class="dd-chart-container">
      <div
        style="width:100%;height:100%;"
        id="chartDiv"
      ></div>
    </div>
    <div class="dd-form-container">
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        layout="vertical"
      >
        <a-form-model-item
          has-feedback
          label="账号"
          prop="username"
        >
          <a-input
            v-model="ruleForm.username"
            type="text"
            autocomplete="off"
            size="large"
            disabled
          >
            <a-icon
              slot="prefix"
              type="user"
            />
          </a-input>
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          label="密码"
          prop="password"
        >
          <a-input
            v-model="ruleForm.password"
            type="password"
            autocomplete="off"
            size="large"
            @keyup.enter.native="submitForm('ruleForm')"
          >
            <a-icon
              slot="prefix"
              type="lock"
            />
          </a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-button
            type="primary"
            @click="submitForm('ruleForm')"
            block
            size="large"
          >
            登录
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div
      class="dd-copyright"
    >
      <!-- <a-row>
        <a-col :span="8"> ©{{ new Date().getFullYear()}} 北京智环成科技发展有限公司</a-col>
        <a-col :span="8">地址：北京市大兴区三合北巷5号院2号楼</a-col>
        <a-col :span="8">技术热线：010-69232818</a-col>
      </a-row> -->
    </div>
  </div>
</template>
<script>
import { getAuthObject, reportStatus } from '../utils/Func';
import * as echarts from 'echarts';
import 'echarts-gl';

export default {
  name: "Login",
  data() {
    let validateLogin = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请插入超级狗'));
      } else {
        callback();
      }
    };
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        username: 'admin',
        password: '',
      },
      rules: {
        username: [{ validator: validateLogin, trigger: 'change' }],
        password: [{ validator: validatePass, trigger: 'change' }]
      },
      scope: '<dogscope/>',
      challenge: '', // 后台返回挑战数据
      authCode: '', // 后台返回authCode,
    };
  },
  methods: {
    initEarthChart() {
      let myChart = echarts.init(document.getElementById('chartDiv'));
      let option = {
        globe: {
          baseTexture: './img/earth.jpg',
          displacementScale: 0.1,
          shading: 'color',
          viewControl: {
            panSensitivity: 0,
            zoomSensitivity: 0,
            rotateSensitivity: 0
          },
          // light: {
          //   ambient: {
          //     intensity: 0.1
          //   },
          //   main: {
          //     intensity: 1.5
          //   }
          // },
        },
      };
      myChart.setOption(option);
      window.addEventListener('resize', () => { myChart.resize() });
    },
    submitForm(formName) {
      let self = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$httpPost("zserver/api/authenticate", this.ruleForm).then((res) => {
            if (res && res.headers) {
              const authToken = res.headers.authorization;
              self.$store.commit("setToken", authToken);
              this.$router.push("/");
            }
          }, err => {
            if (err && err.response) {
              const statusCode = err.response.status;
              if (statusCode === 401) {
                self.$message.warn("用户名或密码错误", 2);
              }
            } else {
              self.$message.warn("服务异常", 2);
              console.error(err);
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    checkDog() {
      //Get object
      const objAuth = getAuthObject();
      if ((navigator.userAgent.indexOf("Chrome") > 0) || (navigator.userAgent.indexOf("Firefox") > 0)) {
        objAuth.GetUserNameEx(this.scope, this.authCode);
      } else {
        //Open Dog
        let stat = objAuth.Open(this.scope, this.authCode);
        if (0 != stat) {
          this.$message.warn(reportStatus(stat));
        } else {
          stat = objAuth.GetUserName();
          if (stat != 0) {
            objAuth.Close();
            this.$message.warn(reportStatus(stat));
          } else {
            this.ruleForm.username = objAuth.UserNameStr;
          }
        }
      }
      //Execute the check again after 2 seconds
      this.$global.timer = setTimeout(this.checkDog, 2000);
    },
    loadFunc() {
      // window.parent.removeEventListener("message", this.chromeEventListener, false);
      // if ((navigator.userAgent.indexOf("Chrome") > 0) || (navigator.userAgent.indexOf("Firefox") > 0)) {
      //   window.parent.addEventListener("message", this.chromeEventListener, false);
      // }
      window.parent.onmessage = e => {
        this.chromeEventListener(e);
      }
    },
    chromeEventListener(event) {
      let self = this;
      if (event.data.type == "SNTL_FROM_HOST") {
        var ReturnText = event.data.text;
        if ("GetUserNameEx" == ReturnText.InvokeMethod) {
          if (0 == ReturnText.Status) {
            this.ruleForm.username = ReturnText.UserNameStr;
            if (!ReturnText.UserNameStr) {
              this.$message.warn("当前狗中缺少有效用户信息")
            }
          } else {
            this.ruleForm.username = "";
            this.$message.warn(reportStatus(parseInt(ReturnText.Status)));
            if (self.$router.history.current.path != "/login") {
              self.$router.push("/login");
            }
          }
        } else if ("GetDigestEx" == ReturnText.InvokeMethod) {
          if (0 == ReturnText.Status) {
            const dogID = ReturnText.DogIdStr;
            const digest = ReturnText.DigestStr;
            this.verifyDigest(dogID, digest);
          } else {
            this.$message.warn(reportStatus(parseInt(ReturnText.Status)));
          }
        }
      }
    },
    verifyDigest(dogId, digest, objAuth) {
      this.$httpGet("zserver/api/dog/verify_digest", { "dogId": dogId, "digest": digest, "challenge": this.challenge, "username": this.ruleForm.username }).then(res => {
        if (objAuth) {
          objAuth.close();
        }
        if (res.data) {
          if (res.data != "0") {
            this.$message.warn(reportStatus(parseInt(res.data)));
          } else {
            if (res.headers) {
              const authToken = res.headers.authorization;
              this.$store.commit("setToken", authToken);
              this.$router.push("/");
            }
          }
        }
      })
    },
    getAuthCode() {
      this.$httpGet("zserver/api/dog/auth_code").then(res => {
        if (res.data) {
          this.authCode = res.data;
          this.$store.commit("setAuthoCode", this.authCode);
          if (this.$global.timer) {
            clearTimeout(this.$global.timer);
          }
          this.checkDog();
        }
      })
    },
    getChallenge() {
      this.$httpGet("zserver/api/dog/challenge", { login: this.ruleForm.username }).then(res => {
        if (res.data) {
          const objAuth = getAuthObject();
          const challenge = res.data;
          if (challenge.length < 32) {
            if (challenge == "001") {
              reportStatus(916);
            } else if (challenge == "002") {
              reportStatus(917);
            } else if (challenge == "003") {
              reportStatus(921);
            } else {
              reportStatus(918);
            }
            return;
          }
          this.challenge = challenge;
          if ((navigator.userAgent.indexOf("Chrome") > 0) || (navigator.userAgent.indexOf("Firefox") > 0)) {
            objAuth.GetDigestEx(this.scope, this.authCode, this.ruleForm.password, challenge);
          } else {
            //for ie
            let stat = objAuth.Open(this.scope, this.authCode);
            if (stat != 0) {
              this.$message.warn(reportStatus(stat));
              return;
            }
            //Verify the password
            stat = objAuth.VerifyUserPin(this.ruleForm.password);
            if (stat != 0) {
              objAuth.Close();
              this.$message.warn(reportStatus(stat));
              return;
            }
            //Get the DogID
            stat = objAuth.GetDogID();
            if (stat != 0) {
              objAuth.Close();
              this.$message.warn(reportStatus(stat));
              return;
            }
            const dogId = objAuth.DogIdStr;
            //Generate digest
            stat = objAuth.GetDigest(challenge);
            if (stat != 0) {
              objAuth.Close();
              this.$message.warn(reportStatus(stat));
              return;
            }
            const digest = objAuth.DigestStr;
            this.verifyDigest(dogId, digest, objAuth);
          }
        }
      })
    },
    submitLoginByDog() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.getChallenge();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  mounted() {
    // this.loadFunc();
    this.$nextTick((e) => {
      this.initEarthChart();
      // this.getAuthCode();
    })
  }
};
</script>
<style lang="scss" scoped>
.dd-chart-container {
  position: absolute;
  right: 10%;
  top: 10%;
  bottom: 10%;
  left: 50%;
}
.dd-system-title {
  // width: 385px;
  height: 29px;
  font-size: 50px;
  font-family: FZLanTingHei-R-GBK;
  font-weight: bold;
  // letter-spacing: 10px;
  color: #ffffff;
  line-height: 60px;
  display: block;
  text-align: center;
  position: absolute;
  left: calc(20% - 100px);
  left: -moz-calc(20% - 100px);
  left: -webkit-calc(20% - 100px);
  top: calc(25% - 70px);
  top: -moz-calc(25% - 70px);
  top: -webkit-calc(25% - 70px);
}
.dd-container {
  width: 100%;
  height: 100%;
  // background: url("../assets/login_background.jpg");
  // background-size: 100%;
  background-image: linear-gradient(-180deg, #1a1454 0%, #0e81a5 100%);
  background-repeat: no-repeat;
  background-size: cover;
}
.dd-form-container {
  position: absolute;
  left: 20%;
  top: 25%;
  padding: 10px;
  width: 385px;
  height: 370px;
  background: #ffffff;
  opacity: 0.9;
  border-radius: 5px;
  & button {
    // background: #00bb59;
    border-radius: 20px;
  }
}
.dd-copyright {
  text-align: center;
  width: 100%;
  position: absolute;
  left: 0px;
  font-size: 16px;
  padding: 5px;
  bottom: 0px;
  font-family: FZLanTingHei-R-GBK;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
}
</style>
<style lang="scss">
.dd-form-container {
  .ant-form-item label {
    font-size: 18px;
    font-family: FZLanTingHei-R-GBK;
    font-weight: 400;
    color: #6f6f6f;
  }
}
</style>